<script setup lang="ts">
</script>

<template>
  <main class="get-quote-page">
    <section class="form">
      <QuoteForm product="school" />
    </section>
  </main>
</template>

<style scoped lang="scss">
.get-quote-page {
  display: flex;
  flex-wrap: wrap;

  section {
    align-content: center;
    padding: 1rem;
  }

  section.form {
    flex: 1 1 25rem;
    max-width: 40rem;
  }
}
</style>
